/**
 * Chat Demo Page
 * 
 * Demonstrates the embeddable chat widget functionality
 */

import React from "react";
import EmbeddableChatWidget from "../components/chat/embeddable-chat-widget";

const ChatDemoPage: React.FC = () => {
  return (
    <div style={{ 
      minHeight: "100vh", 
      backgroundColor: "#f5f5f5",
      padding: "40px 20px",
      fontFamily: "system-ui, -apple-system, sans-serif"
    }}>
      <div style={{ 
        maxWidth: "800px", 
        margin: "0 auto",
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "40px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
      }}>
        <h1 style={{ 
          color: "#333", 
          marginBottom: "20px",
          fontSize: "32px",
          fontWeight: "600"
        }}>
          activQMS Chat Widget Demo
        </h1>
        
        <p style={{ 
          color: "#666", 
          fontSize: "18px", 
          lineHeight: "1.6",
          marginBottom: "30px"
        }}>
          This page demonstrates the embeddable chat widget that can be integrated 
          into any website. The chat widget uses the existing activQMS GraphQL API 
          with public access support, allowing visitors to start conversations 
          without authentication.
        </p>

        <div style={{ 
          backgroundColor: "#f8f9fa", 
          padding: "20px", 
          borderRadius: "8px",
          marginBottom: "30px"
        }}>
          <h3 style={{ color: "#333", marginBottom: "15px" }}>Features:</h3>
          <ul style={{ color: "#666", lineHeight: "1.8" }}>
            <li>✅ No authentication required for visitors</li>
            <li>✅ Real-time messaging using GraphQL subscriptions</li>
            <li>✅ Responsive design that works on all devices</li>
            <li>✅ Customizable theme and positioning</li>
            <li>✅ Integrates with existing activQMS backend</li>
            <li>✅ Supports auto-responders and AI chat</li>
            <li>✅ Admin dashboard integration for managing conversations</li>
          </ul>
        </div>

        <div style={{ 
          backgroundColor: "#e3f2fd", 
          padding: "20px", 
          borderRadius: "8px",
          marginBottom: "30px"
        }}>
          <h3 style={{ color: "#1976d2", marginBottom: "15px" }}>How to Use:</h3>
          <ol style={{ color: "#666", lineHeight: "1.8" }}>
            <li>Look for the chat button in the bottom-right corner</li>
            <li>Click the chat button to open the chat window</li>
            <li>Start typing your message and press Enter or click send</li>
            <li>The conversation will be saved and can be managed from the admin dashboard</li>
          </ol>
        </div>

        <div style={{ 
          backgroundColor: "#fff3e0", 
          padding: "20px", 
          borderRadius: "8px",
          marginBottom: "30px"
        }}>
          <h3 style={{ color: "#f57c00", marginBottom: "15px" }}>Integration:</h3>
          <p style={{ color: "#666", lineHeight: "1.6", marginBottom: "15px" }}>
            To embed this chat widget on any website, simply add the following code:
          </p>
          <pre style={{ 
            backgroundColor: "#2d3748", 
            color: "#e2e8f0", 
            padding: "15px", 
            borderRadius: "6px",
            fontSize: "14px",
            overflow: "auto"
          }}>
{`<script src="https://your-domain.com/chat-widget.js"></script>
<script>
  ActivQMSChat.init({
    campaignId: 'your-campaign-id',
    assetId: 'your-asset-id',
    theme: {
      primaryColor: '#007bff',
      backgroundColor: '#ffffff'
    },
    position: 'bottom-right'
  });
</script>`}
          </pre>
        </div>

        <div style={{ 
          textAlign: "center",
          padding: "20px"
        }}>
          <p style={{ 
            color: "#999", 
            fontSize: "16px",
            marginBottom: "10px"
          }}>
            Try the chat widget now! 👉
          </p>
          <p style={{ 
            color: "#666", 
            fontSize: "14px"
          }}>
            Click the chat button in the bottom-right corner to start a conversation.
          </p>
        </div>
      </div>

      {/* Embeddable Chat Widget */}
      <EmbeddableChatWidget
        campaignId="demo-campaign"
        assetId="demo-widget"
        conversationId={`demo-${Date.now()}`}
        customerInfo={{
          name: "Demo User",
          email: "demo@example.com"
        }}
        theme={{
          primaryColor: "#007bff",
          backgroundColor: "#ffffff",
          textColor: "#333333"
        }}
        position="bottom-right"
        minimized={true}
      />
    </div>
  );
};

export default ChatDemoPage;
